'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_RootPage$() {
}
export { $c_Lapp_pages_RootPage$ as $c_Lapp_pages_RootPage$ };
$p = $c_Lapp_pages_RootPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_RootPage$;
/** @constructor */
function $h_Lapp_pages_RootPage$() {
}
export { $h_Lapp_pages_RootPage$ as $h_Lapp_pages_RootPage$ };
$h_Lapp_pages_RootPage$.prototype = $p;
$p.au8 = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_PageRenderResult($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().b.af().o($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().d(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().b, "Welcome to CHQmate!", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_RenderableText$().S)]))), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_PageTitleResult$().j3);
});
var $d_Lapp_pages_RootPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_RootPage$, "app.pages.RootPage$", ({
  HR: 1
}));
export { $d_Lapp_pages_RootPage$ as $d_Lapp_pages_RootPage$ };
var $n_Lapp_pages_RootPage$;
function $m_Lapp_pages_RootPage$() {
  if ((!$n_Lapp_pages_RootPage$)) {
    $n_Lapp_pages_RootPage$ = new $c_Lapp_pages_RootPage$();
  }
  return $n_Lapp_pages_RootPage$;
}
export { $m_Lapp_pages_RootPage$ as $m_Lapp_pages_RootPage$ };
//# sourceMappingURL=app.pages.-Root-Page$.js.map
